import HeaderInner from "../comp/head-navs-inner";
import ViewContentSmall from "../comp/view-content-sm";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import TeamViewModule from "../comp/team-view";

export default function TeamInfo() {

  return (
    <>
      <HeaderInner name={'Student Info'} link={'/bz/team'}/>
      <ViewContentSmall 
        content={
          <>
            <TeamViewModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
    </>
  )
}